import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { FiHome, FiSettings, FiShoppingCart, FiUsers } from "react-icons/fi";
import { useStateContext } from "../contexts/ContextProvider";
import { BsCalendar2Range, BsFillBuildingFill } from "react-icons/bs";
import { PiNotePencilBold, PiStudentBold } from "react-icons/pi";
import { FaCashRegister, FaMoneyBillTrendUp } from "react-icons/fa6";
import { GiMaterialsScience } from "react-icons/gi";
import { IoSettingsSharp } from "react-icons/io5";
import icon from '../data/icon.png';
import { LuFileSpreadsheet } from "react-icons/lu";
import { MdEditNote } from "react-icons/md";

export default function Sidebar2({ }) {
  const [openDropdown, setOpenDropdown] = useState(null);
  const { activeMenu, setActiveMenu, screenSize, user, currentColor } = useStateContext();
  const handleCloseSidebar = () => {
    if (screenSize <= 900) {
      setActiveMenu(false);

    }
  }
  const activeLink =
    "flex items-center gap-2 p-2 rounded-lg text-white font-bold";
  const normalLink =
    "flex items-center gap-2 p-2 rounded-lg hover:bg-gray-100";
  const menuDretude = [
    {
      label: "classes",
      labelAr: "الأقسام",
      link: "/classes",
      icon: <BsFillBuildingFill />,
    },
    {
      label: "Elèves",
      labelAr: "التلاميذ",
      icon: <PiStudentBold />,
      subLinks: [
        { label: "Inscriptions", labelAr: "التسجيلات", link: "/inscriptions" },
        { label: "Absences", labelAr: "الغيابات", link: "/absences" },
        { label: "Observations", labelAr: "الملاحظـات", link: "/observations" },
      ],
    },
    {
      label: "Pédagogie",
      labelAr: "التـربـيـة ",
      icon: <GiMaterialsScience />,
      subLinks: [
        { label: "Examens", labelAr: "الإمـتحـانـات", link: "/examens" },
        { label: "Devoirs", labelAr: "الإختـبـارات", link: "/devoirs" },
        { label: "Emploie du temps", labelAr: "الجدول الزمني", link: "/emploies" },
        { label: "Bulletins de notes", labelAr: "كشوف الدرجات", link: "/bulletins" },
        { label: "Matières", labelAr: "المــواد", link: "/matieres" },
        { label: "Coefficients", labelAr: "الضوارب و التنقيط", link: "/coefficients" },
      ],
    },
    {
      label: "Paramètres",
      labelAr: "إعدادات",
      icon: <IoSettingsSharp />,
      subLinks: [
        { label: "Types d'observation", labelAr: "أنواع الملاحظة", link: "/typesobsevation" },
      ],
    },
  ];
  const menuEnseignant = [
    {
      label: "Emploie du temps",
      labelAr: "الجدول الزمني",
      link: "/monemploie",
      icon: <BsCalendar2Range />,
    },
    {
      label: "Examens",
      labelAr: "الإمـتحـانـات",
      link: "/mesexamens",
      icon: <MdEditNote />,
    },
    {
      label: "Devoirs",
      labelAr: "الإختـبـارات",
      link: "/mesdevoirs",
      icon: <PiNotePencilBold />,
    },
    
  ];
  const menuCaissier = [
    {
      label: "classes",
      labelAr: "الأقسام",
      link: "/classes",
      icon: <BsFillBuildingFill />,
    },
    {
      label: "Inscriptions",
      labelAr: "التسجيلات",
      link: "/inscriptions",
      icon: <PiStudentBold />,
    },
    {
      label: "Facturation",
      labelAr: "الفوترة",
      link: "/factures",
      icon: <LuFileSpreadsheet />,
    },
    
    {
      label: "Dépenses",
      labelAr: "المصاريف",
      icon: <FiShoppingCart />,
      subLinks: [
        { label: "Dépenses", labelAr: "المصاريف", link: "/depenses" },
        { label: "Dépenses Analytics", labelAr: "تحليل المصاريف", link: "/depensesDash" },
      ],
    },
    {
      label: "Caisse",
      labelAr: "الصندوق",
      icon: <FaCashRegister />,
      subLinks: [
        { label: "Alimentations", labelAr: "المداخيل الأخرى", link: "/alimentations" },
        { label: "Sorties Caisse", labelAr: "المخاريج", link: "/Sorties" },
        { label: "Situations Caisse", labelAr: "وضعية الصندوق", link: "/situations" },
      ],
    },
  ];
  const menuItems = [
    {
      label: "Utlisateurs",
      labelAr: "المستخدمين",
      link: "/users",
      icon: <FiUsers />,
    },
    {
      label: "classes",
      labelAr: "الأقسام",
      link: "/classes",
      icon: <BsFillBuildingFill />,
    },
    {
      label: "Elèves",
      labelAr: "التلاميذ",
      icon: <PiStudentBold />,
      subLinks: [
        { label: "Inscriptions", labelAr: "التسجيلات", link: "/inscriptions" },
        { label: "Absences", labelAr: "الغيابات", link: "/absences" },
        { label: "Observations", labelAr: "الملاحظـات", link: "/observations" },
      ],
    },
    {
      label: "Facturation",
      labelAr: "الفوترة",
      icon: <LuFileSpreadsheet />,
      subLinks: [
        { label: "Factures", labelAr: "الفواتــيــر", link: "/factures" },
        { label: "Factures Analytics", labelAr: "تحليل الفواتــيــر", link: "/facturesDash" },
        { label: "Prévisions", labelAr: "التقديرات", link: "/previsions" },

      ],
    },

    {
      label: "Dépenses",
      labelAr: "المصاريف",
      icon: <FiShoppingCart />,
      subLinks: [
        { label: "Dépenses", labelAr: "المصاريف", link: "/depenses" },
        { label: "Dépenses Analytics", labelAr: "تحليل المصاريف", link: "/depensesDash" },
      ],
    },
    {
      label: "Caisse",
      labelAr: "الصندوق",
      icon: <FaCashRegister />,
      subLinks: [
        { label: "Alimentations", labelAr: "المداخيل الأخرى", link: "/alimentations" },
        { label: "Sorties Caisse", labelAr: "المخاريج", link: "/Sorties" },
        { label: "Situations Caisse", labelAr: "وضعية الصندوق", link: "/situations" },
      ],
    },
    {
      label: "Pédagogie",
      labelAr: "التـربـيـة ",
      icon: <GiMaterialsScience />,
      subLinks: [
        { label: "Examens", labelAr: "الإمـتحـانـات", link: "/examens" },
        { label: "Devoirs", labelAr: "الإختـبـارات", link: "/devoirs" },
        { label: "Emploie du temps", labelAr: "الجدول الزمني", link: "/emploies" },
        { label: "Bulletins de notes", labelAr: "كشوف الدرجات", link: "/bulletins" },
        { label: "Matières", labelAr: "المــواد", link: "/matieres" },
        { label: "Coefficients", labelAr: "الضوارب و التنقيط", link: "/coefficients" },

      ],
    },
    {
      label: "Paramètres",
      labelAr: "إعدادات",
      icon: <IoSettingsSharp />,
      subLinks: [
        { label: "Historiques", labelAr: "أرشيف", link: "/historiques" },
        { label: "Types d'observation", labelAr: "أنواع الملاحظة", link: "/typesobsevation" },



      ],
    },
  ];

  const toggleDropdown = (index) => {
    setOpenDropdown(openDropdown === index ? null : index);
  };

  return (
    <div className="w-full bg-white overflow-auto shadow-lg h-full p-3">
      <div onClick={() => setActiveMenu((prevActiveMenu) => !prevActiveMenu)} className="flex w-full h-40 mt-3 mb-6 justify-center items-center bg-gradient-to-r  rounded-xl shadow-lg transition-all duration-300 hover:scale-105">
        <img
          className="mx-auto h-32 w-auto transform transition-transform duration-300 hover:rotate-6"
          src={icon}
          alt="Your Company"
        />
      </div>

      {user.role && user.role.name==="admin" ?
        menuItems.map((item, index) => (
          <div key={index} className="mb-2">
            {/* Si sous-menu */}
            {item.subLinks ? (
              <>
                <button
                  onClick={() => toggleDropdown(index)}
                  className={
                    normalLink +
                    " w-full flex justify-between items-center"
                  }
                >
                  {user.langue === "AR" ? (
                    <div className="flex gap-2 w-full justify-end">
                      <span className="font-bold">{item.labelAr}</span>
                      {item.icon}
                    </div>
                  ) : (
                    <div className="flex gap-2">
                      {item.icon}
                      <span>{item.label}</span>
                    </div>
                  )}
                  {openDropdown === index ? <FaChevronUp /> : <FaChevronDown />}
                </button>

                {/* Sous-menu */}
                {openDropdown === index && (
                  <div className="ml-6 mt-1 space-y-1">
                    {item.subLinks.map((sub, i) => (
                      <NavLink
                        key={i}
                        to={sub.link}
                        onClick={handleCloseSidebar}
                        className={({ isActive }) =>
                          isActive ? activeLink + " pl-4" : normalLink + " pl-4"
                        }
                        style={({ isActive }) =>
                          isActive
                            ? { backgroundColor: `${currentColor}` }
                            : { backgroundColor: "white" }
                        }
                      >
                        {user.langue === "AR" ? sub.labelAr : sub.label}
                      </NavLink>
                    ))}
                  </div>
                )}
              </>
            ) : (
              // Lien simple
              <NavLink
                to={item.link}
                onClick={handleCloseSidebar}
                className={({ isActive }) =>
                  isActive ? activeLink : normalLink
                }
                style={({ isActive }) =>
                  isActive
                    ? { backgroundColor: `${currentColor}` }
                    : { backgroundColor: "white" }
                }
              >
                {user.langue === "AR" ? (
                  <div className="flex gap-2 w-full justify-end">
                    <span className="font-bold">{item.labelAr}</span>
                    {item.icon}
                  </div>
                ) : (
                  <div className="flex gap-2">
                    {item.icon}
                    <span>{item.label}</span>
                  </div>
                )}
              </NavLink>
            )}
          </div>
        ))
        :
        user.role && user.role.name==="dretude" ?
        menuDretude.map((item, index) => (
          <div key={index} className="mb-2">
            {/* Si sous-menu */}
            {item.subLinks ? (
              <>
                <button
                  onClick={() => toggleDropdown(index)}
                  className={
                    normalLink +
                    " w-full flex justify-between items-center"
                  }
                >
                  {user.langue === "AR" ? (
                    <div className="flex gap-2 w-full justify-end">
                      <span className="font-bold">{item.labelAr}</span>
                      {item.icon}
                    </div>
                  ) : (
                    <div className="flex gap-2">
                      {item.icon}
                      <span>{item.label}</span>
                    </div>
                  )}
                  {openDropdown === index ? <FaChevronUp /> : <FaChevronDown />}
                </button>

                {/* Sous-menu */}
                {openDropdown === index && (
                  <div className="ml-6 mt-1 space-y-1">
                    {item.subLinks.map((sub, i) => (
                      <NavLink
                        key={i}
                        to={sub.link}
                        onClick={handleCloseSidebar}
                        className={({ isActive }) =>
                          isActive ? activeLink + " pl-4" : normalLink + " pl-4"
                        }
                        style={({ isActive }) =>
                          isActive
                            ? { backgroundColor: `${currentColor}` }
                            : { backgroundColor: "white" }
                        }
                      >
                        {user.langue === "AR" ? sub.labelAr : sub.label}
                      </NavLink>
                    ))}
                  </div>
                )}
              </>
            ) : (
              // Lien simple
              <NavLink
                to={item.link}
                onClick={handleCloseSidebar}
                className={({ isActive }) =>
                  isActive ? activeLink : normalLink
                }
                style={({ isActive }) =>
                  isActive
                    ? { backgroundColor: `${currentColor}` }
                    : { backgroundColor: "white" }
                }
              >
                {user.langue === "AR" ? (
                  <div className="flex gap-2 w-full justify-end">
                    <span className="font-bold">{item.labelAr}</span>
                    {item.icon}
                  </div>
                ) : (
                  <div className="flex gap-2">
                    {item.icon}
                    <span>{item.label}</span>
                  </div>
                )}
              </NavLink>
            )}
          </div>
        ))
        :
        user.role && user.role.name==="enseignant" ?
        menuEnseignant.map((item, index) => (
          <div key={index} className="mb-2">
            {/* Si sous-menu */}
            {item.subLinks ? (
              <>
                <button
                  onClick={() => toggleDropdown(index)}
                  className={
                    normalLink +
                    " w-full flex justify-between items-center"
                  }
                >
                  {user.langue === "AR" ? (
                    <div className="flex gap-2 w-full justify-end">
                      <span className="font-bold">{item.labelAr}</span>
                      {item.icon}
                    </div>
                  ) : (
                    <div className="flex gap-2">
                      {item.icon}
                      <span>{item.label}</span>
                    </div>
                  )}
                  {openDropdown === index ? <FaChevronUp /> : <FaChevronDown />}
                </button>

                {/* Sous-menu */}
                {openDropdown === index && (
                  <div className="ml-6 mt-1 space-y-1">
                    {item.subLinks.map((sub, i) => (
                      <NavLink
                        key={i}
                        to={sub.link}
                        onClick={handleCloseSidebar}
                        className={({ isActive }) =>
                          isActive ? activeLink + " pl-4" : normalLink + " pl-4"
                        }
                        style={({ isActive }) =>
                          isActive
                            ? { backgroundColor: `${currentColor}` }
                            : { backgroundColor: "white" }
                        }
                      >
                        {user.langue === "AR" ? sub.labelAr : sub.label}
                      </NavLink>
                    ))}
                  </div>
                )}
              </>
            ) : (
              // Lien simple
              <NavLink
                to={item.link}
                onClick={handleCloseSidebar}
                className={({ isActive }) =>
                  isActive ? activeLink : normalLink
                }
                style={({ isActive }) =>
                  isActive
                    ? { backgroundColor: `${currentColor}` }
                    : { backgroundColor: "white" }
                }
              >
                {user.langue === "AR" ? (
                  <div className="flex gap-2 w-full justify-end">
                    <span className="font-bold">{item.labelAr}</span>
                    {item.icon}
                  </div>
                ) : (
                  <div className="flex gap-2">
                    {item.icon}
                    <span>{item.label}</span>
                  </div>
                )}
              </NavLink>
            )}
          </div>
        ))
        :
        user.role && user.role.name==="caissier" ?
        menuCaissier.map((item, index) => (
          <div key={index} className="mb-2">
            {/* Si sous-menu */}
            {item.subLinks ? (
              <>
                <button
                  onClick={() => toggleDropdown(index)}
                  className={
                    normalLink +
                    " w-full flex justify-between items-center"
                  }
                >
                  {user.langue === "AR" ? (
                    <div className="flex gap-2 w-full justify-end">
                      <span className="font-bold">{item.labelAr}</span>
                      {item.icon}
                    </div>
                  ) : (
                    <div className="flex gap-2">
                      {item.icon}
                      <span>{item.label}</span>
                    </div>
                  )}
                  {openDropdown === index ? <FaChevronUp /> : <FaChevronDown />}
                </button>

                {/* Sous-menu */}
                {openDropdown === index && (
                  <div className="ml-6 mt-1 space-y-1">
                    {item.subLinks.map((sub, i) => (
                      <NavLink
                        key={i}
                        to={sub.link}
                        onClick={handleCloseSidebar}
                        className={({ isActive }) =>
                          isActive ? activeLink + " pl-4" : normalLink + " pl-4"
                        }
                        style={({ isActive }) =>
                          isActive
                            ? { backgroundColor: `${currentColor}` }
                            : { backgroundColor: "white" }
                        }
                      >
                        {user.langue === "AR" ? sub.labelAr : sub.label}
                      </NavLink>
                    ))}
                  </div>
                )}
              </>
            ) : (
              // Lien simple
              <NavLink
                to={item.link}
                onClick={handleCloseSidebar}
                className={({ isActive }) =>
                  isActive ? activeLink : normalLink
                }
                style={({ isActive }) =>
                  isActive
                    ? { backgroundColor: `${currentColor}` }
                    : { backgroundColor: "white" }
                }
              >
                {user.langue === "AR" ? (
                  <div className="flex gap-2 w-full justify-end">
                    <span className="font-bold">{item.labelAr}</span>
                    {item.icon}
                  </div>
                ) : (
                  <div className="flex gap-2">
                    {item.icon}
                    <span>{item.label}</span>
                  </div>
                )}
              </NavLink>
            )}
          </div>
        ))
        :
        user.role && user.role.name==="super_admin" ?
        menuItems.map((item, index) => (
          <div key={index} className="mb-2">
            {/* Si sous-menu */}
            {item.subLinks ? (
              <>
                <button
                  onClick={() => toggleDropdown(index)}
                  className={
                    normalLink +
                    " w-full flex justify-between items-center"
                  }
                >
                  {user.langue === "AR" ? (
                    <div className="flex gap-2 w-full justify-end">
                      <span className="font-bold">{item.labelAr}</span>
                      {item.icon}
                    </div>
                  ) : (
                    <div className="flex gap-2">
                      {item.icon}
                      <span>{item.label}</span>
                    </div>
                  )}
                  {openDropdown === index ? <FaChevronUp /> : <FaChevronDown />}
                </button>

                {/* Sous-menu */}
                {openDropdown === index && (
                  <div className="ml-6 mt-1 space-y-1">
                    {item.subLinks.map((sub, i) => (
                      <NavLink
                        key={i}
                        to={sub.link}
                        onClick={handleCloseSidebar}
                        className={({ isActive }) =>
                          isActive ? activeLink + " pl-4" : normalLink + " pl-4"
                        }
                        style={({ isActive }) =>
                          isActive
                            ? { backgroundColor: `${currentColor}` }
                            : { backgroundColor: "white" }
                        }
                      >
                        {user.langue === "AR" ? sub.labelAr : sub.label}
                      </NavLink>
                    ))}
                  </div>
                )}
              </>
            ) : (
              // Lien simple
              <NavLink
                to={item.link}
                onClick={handleCloseSidebar}
                className={({ isActive }) =>
                  isActive ? activeLink : normalLink
                }
                style={({ isActive }) =>
                  isActive
                    ? { backgroundColor: `${currentColor}` }
                    : { backgroundColor: "white" }
                }
              >
                {user.langue === "AR" ? (
                  <div className="flex gap-2 w-full justify-end">
                    <span className="font-bold">{item.labelAr}</span>
                    {item.icon}
                  </div>
                ) : (
                  <div className="flex gap-2">
                    {item.icon}
                    <span>{item.label}</span>
                  </div>
                )}
              </NavLink>
            )}
          </div>
        ))
        :
        <></>

        
      }
    </div>
  );
}
